import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb, VhImage, VhEventMediator, VhAlgorithm } from 'vhautowebdb';
import { MatDialog } from '@angular/material/dialog';
import { NzPlacementType } from 'ng-zorro-antd/dropdown';
import { forkJoin, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';
import { LanguageService } from 'vhobjects-service/src/services';
import { FunctionService  } from 'vhobjects-service';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'atw-frame-search-by-keyword-admin-config',
  templateUrl: './frame-search-by-keyword-admin-config.component.html',
  styleUrls: ['./frame-search-by-keyword-admin-config.component.scss']
})
export class AtwFrameSearchByKeywordAdminConfig extends AtwUpdateDbComponent implements OnInit {
@Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Output() changeOptionConfig = new EventEmitter<any>();
  public isViewAll: boolean = false;
  public isCollapsed: boolean = false;
  positionSelect: NzPlacementType = 'bottomCenter';
  public currentViewAll: any = {};
  // Xử lý chỉ mở được 1 menu 1 lần
  public openMenu: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };
  public urlBackgroundImage = ''; // Hình ảnh nền của frame (nếu có)
  public gapSpace = 0;
  public loadComplete = false;
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_phan_tu',
      index: 2,
    },
    {
      title: 'hieu_ung',
      index: 3,
    },
  ];
  fonts = [

  ]
  animation: any = {};
  effect_hover = [];
  customize = [];
  public bootstrapIconArrows: any = [
    {
      icon_left: 'bi bi-chevron-left',
      icon_right: 'bi bi-chevron-right'
    },
    {
      icon_left: 'bi bi-arrow-left-short',
      icon_right: 'bi bi-arrow-right-short'
    },
    {
      icon_left: 'bi bi-caret-left-fill',
      icon_right: 'bi bi-caret-right-fill'
    },
    {
      icon_left: 'bi bi-chevron-compact-left',
      icon_right: 'bi bi-chevron-compact-right'
    },
  ]
  configMode: 'basic' | 'advanced' = 'basic';
  openFixedIdCate: boolean = false;
  currentCategory: any;
  tempSearchCategory = ''; // biến trung gian
  searchCategory = '';
  resultSearchCategory = [];
  private searchCategoryChange = new Subject<string>();
  isLoadingSearchCategory = false;
  categories: any[] = []; // biến này lưu danh sách danh mục cho cầu hình hiển thị sản phẩm theo danh mục cố định

  main_sectors: any = [];
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    private http: HttpClient,
    private vhAlgorithm: VhAlgorithm,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
    private languageService: LanguageService,
  ) { 
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if(!this.config.hasOwnProperty('fixed_id_category')) {
        this.config.fixed_id_category = 'none';
      }

      forkJoin([
        this.http.get('assets/data/group/main_sectors.json'),
        this.http.get('assets/fonts/fonts.json'),
        this.http.get('assets/data/effects/frame-products.json')
      ]).subscribe(([main_sectors, fonts, effects]: any) => {
        this.fonts = fonts;
        this.main_sectors = this.vhAlgorithm.sortVietnamesebyASC(main_sectors.filter((item) => !['basic', 'branchs', 'member'].includes(item.value)), 'label')
        this.effect_hover = effects;
      })

      if (this.class && this.config) {
        this.loadComplete = true;
        // Khoảng cách giữa cột và dòng
        this.gapSpace = parseInt(
          this.class['frame-search-by-keyword__products']['gap'],
          10
        );
      }

      // đoạn này để xử lý khi người dùng ngưng gõ 300ms thì mới thực hiện tìm kiếm
      this.searchCategoryChange.pipe(
        debounceTime(300), // thay đổi thời gian chờ ở đây
      ).subscribe(newValue => {
        this.isLoadingSearchCategory = false; // người dùng ngừng gõ
        this.handleSearchCategory(newValue);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId))
      if (changes) {
        if (changes.objectChoosing) {
          this.getCategories();
        }
        if (changes.device) this.device = changes.device.currentValue;
      }
  }

  getCategories() {
    if (!this.objectChoosing || !this.device) return;
    this.vhQueryAutoWeb
      .getCategorys_byFields({}, {})
      .then((rsp: any) => {
        const categories = rsp.data.map((e) => {
          const array_step = [];
          for (let i = 0; i < e.step; i++) {
            array_step.push(i);
          }

          const item = { ...e, array_step };

          if (e._id === this.objectChoosing[`${this.device}_config`].fixed_id_category) {
            this.currentCategory = item;
          }

          return item;
        });

        this.categories = this.vhAlgorithm.sortVietnamesebyASC(categories, 'name_' + this.functionService.selectedLanguageCode);
        console.log
      })
      .catch((error) => {
        console.error('Error fetching categories:', error);
      });
  }

  /**
   * Chọn danh mục
   * @param cate: mục danh mục sẽ chọn
   */
  chooseCategory(cate) {
    this.openFixedIdCate = false;
    this.config.fixed_id_category = cate === 'none' ? 'none' : cate._id;
    this.currentCategory = cate;

    this.updateConfig();
  }

  /**
   * 
   * @param value giá trị tìm kiếm
   * sau khi người dùng ngưng gõ 300ms mới thực hiện hàm này
   */
  private handleSearchCategory(value: string): void {
    const resultSearchCategory = this.searchList(value, JSON.parse(JSON.stringify(this.categories)), ['name_' + this.functionService.selectedLanguageCode]);
    this.resultSearchCategory = this.vhAlgorithm.sortStringbyASC(resultSearchCategory, 'name_' + this.functionService.selectedLanguageCode);
  }

  /**
   * 
   * @param str hàm bỏ dấu tiếng việt
   * @returns 
   */
  private removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D");
  }

  /**
   * 
   * @param value giá trị tìm kiếm
   * @param data dữ liệu cần tìm kiếm
   * @param field trường cần tìm kiếm
   * @returns 
   */
  private searchList(value: string, data: any[] = [], field: string[]): any[] {
    let result = [];
    value = this.removeAccents(value.toLowerCase());
    for (let item of data) {
      let itemValue = this.removeAccents(item[field[0]].toLowerCase());
      itemValue = this.removeAccents(this.languageService.translate(itemValue).toLowerCase());
      if (itemValue.includes(value)) {
        result.push(item);
      }
    }
    return result;
  }

  /**
   * 
   * @param value giá trị tìm kiếm
   * hàm này thực hiện gọi hàm searchValueChange.next(value) để thực hiện tìm kiếm
   * 
   */
  onSearchCategoryChange(value: string) {
    this.isLoadingSearchCategory = true; // Thiết lập isLoading thành true trước khi gán giá trị cho tempSearchValue
    this.tempSearchCategory = value;
    this.searchCategoryChange.next(value);
  }

  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation(); // ✅ chặn click lan ra ngoài
    this.openFixedIdCate = !this.openFixedIdCate;

    if (this.openFixedIdCate && this.currentCategory?._id !== undefined && this.currentCategory?._id !== 'none') {
      const linkToSearch = this.currentCategory._id;
      setTimeout(() => {
        const selector = `[data-id="${this.currentCategory._id}"]`;
        const targetElement = document.querySelector(selector); 

        if (targetElement) {
          // Thực hiện cuộn
          targetElement.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
        } else {
          console.warn(`Không tìm thấy mục với link "${linkToSearch}" trong dropdown.`);
        }
      }, 100);
    }
  }

  trackByPage(index: number, item: any) {
    return item._id;
  }

  openHandler(value: string): void {
    for (const key in this.openMenu) {
      if (key !== value) {
        this.openMenu[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /** Hàm thực hiện kiểm tra điều kiện 1 hướng của viền và active option đấy nếu đủ điều kiện
   *
   * @param value
   */
  checkActiveDirectionBorder(value: any) {
    if (['0px', '0'].includes(value)) return false;
    return true;
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylesField[2])
  }

  /**
   * Kiểu nút slide
   * @param event
   */
  handleSetDotsStyle(event) {
    switch (event) {
      case 'circle':
        this.class['frame-search-by-keyword__pagination-list-button--controll']['border-radius'] = 50 + 'px';
        this.class['frame-search-by-keyword__pagination-list-button--page-number']['border-radius'] = 50 + 'px';
        this.class['frame-search-by-keyword__pagination-list-button--active']['border-radius'] = 50 + 'px';
        this.config[`slick_dots`]['height'] = this.config[`slick_dots`]['width'];
        break;
      case 'rectangle':
        this.class['frame-search-by-keyword__pagination-list-button--controll']['border-radius'] = 0 + '%';
        this.class['frame-search-by-keyword__pagination-list-button--page-number']['border-radius'] = 0 + '%';
        this.class['frame-search-by-keyword__pagination-list-button--active']['border-radius'] = 0 + '%';
        break;
    }

    this.updateConfig();
    this.updateClass();
  }
  /**
   * Kích thước cho nút next/prev
   *  @param event
   *  @param type nút next hay prev
   */
  handleSetButtonSize(event) {
    var style = this.config[`slick_dots`]['background_style'];

    this.config[`slick_dots`]['width'] = event + 'px';
    this.config['slick_dots']['height'] = event + 'px';
    this.class['frame-search-by-keyword__pagination-list-button--controll']['border-radius'] = 50 + 'px';
    this.class['frame-search-by-keyword__pagination-list-button--page-number']['border-radius'] = 50 + 'px';
    this.class['frame-search-by-keyword__pagination-list-button--active']['border-radius'] = 50 + 'px';

  }

  /** Hàm sẽ thực hiện disable các option khi lựa chọn tải ảnh nền cho frame
   *
   * @param valueItem
   * @returns
   */
  checkDisableUploadImage(valueItem: any) {
    if (this.class['frame-search-by-keyword'].is_upload_image === valueItem)
      return false;
    return true;
  }

  /** Hàm thực hiện cập nhật liên quan khi thay đổi số lượng cột
   *
   * @param event
   */
  handleChangeCols(event: any) {
    this.config['frame-search-by-keyword__products']['cols'] = event;
    // cập nhật trường grid-template-columns
    this.class['frame-search-by-keyword__products']['grid-template-columns'] = `repeat(${this.config['frame-search-by-keyword__products']['cols']}, minmax(0px, 1fr))`;
    // cập nhật trường grid-template-rows
    // this.class['frame-search-by-keyword__products']['grid-template-rows'] = `repeat(${
    //   this.config['frame-search-by-keyword__products'].rows
    // },${this.calcSpaceGrid(this.config['frame-search-by-keyword__products'].rows)})`;
    // Cập nhật tường grid-auto-columns
    // this.class['frame-search-by-keyword__products'][
    //   'grid-auto-columns'
    // ] = `${this.calcSpaceGrid(this.config['frame-search-by-keyword__products'].cols)}`;
    this.config['frame-search-by-keyword__products']['total_products'] =
      this.config['frame-search-by-keyword__products']['cols'] *
      this.config['frame-search-by-keyword__products']['rows'];
    this.updateClass();
    this.updateConfig();
  }

  /** Hàm thực hiện cập nhật liên quan khi thay đổi số lượng dofng
   *
   * @param event
   */
  handleChangeRows(event: any) {
    this.config['frame-search-by-keyword__products']['rows'] = event;
    // cập nhật trường grid-template-rows

    this.class['frame-search-by-keyword__products']['grid-template-rows'] = `repeat(${this.config['frame-search-by-keyword__products'].rows
      }, minmax(0px, 1fr))`;
    this.config['frame-search-by-keyword__products']['total_products'] =
      this.config['frame-search-by-keyword__products']['cols'] *
      this.config['frame-search-by-keyword__products']['rows'];

    this.updateClass();
    this.updateConfig();
  }
  /** Hàm này trả về một chuỗi để chia layout cho grid
   * @param cols
   * @param gap
   *
   * @example
   * cols = 4
   * gap = 12
   * Kết quả: calc(25% - 9px)
   * @return calc(${100/cols}% - ${(gap/cols)*(cols-1)}px)
   *
   */
  calcSpaceGrid(cols) {
    let gap = parseInt(this.class['frame-search-by-keyword__products'].gap, 10);
    return `calc(${100 / cols}% - ${(gap / cols) * (cols - 1)}px)`;
  }

  /** Hàm thực hiện cập nhật khoảng cách gỡ các dòng cột, xử lý chia cột dòng
   *
   * @param event
   */
  handleChangeGap(event: any) {
    this.class['frame-search-by-keyword__products']['gap'] = `${event}px`;
    this.class['frame-search-by-keyword__products']['grid-template-columns'] = `repeat(${this.config['frame-search-by-keyword__products']['cols']
      },${this.calcSpaceGrid(this.config['frame-search-by-keyword__products'].cols)})`;
    // cập nhật trường grid-template-rows
    this.class['frame-search-by-keyword__products']['grid-template-rows'] = `repeat(${this.config['frame-search-by-keyword__products'].rows
      },${this.calcSpaceGrid(this.config['frame-search-by-keyword__products'].rows)})`;
    // Cập nhật tường grid-auto-columns
    this.class['frame-search-by-keyword__products'][
      'grid-auto-columns'
    ] = `${this.calcSpaceGrid(this.config['frame-search-by-keyword__products'].cols)}`;
    this.updateClass();
  }

  /**
   * Hàm này thay đổi box-shadow giữa có hiệu ứng và không có hiệu ứng.
   * Khi gọi hàm này thì hiệu ứng hover hiển thị box-shadow sẽ bị disable.
   * Ngược lại thì thì hiệu ứng hover hiển thị box-shadow enable.
   * @param event : trả về giá trị true false
   */
  onChangeShadow(event: any) {
    // Lấy giá trị true false của tham số event
    this.config['frame-search-by-keyword__products--item']['is_box_shadow'] = event;
    // Khi giá trị trả về false, set style box-shadow về mặc định.
    // Khi giá trị trả về true, set style box-shadow theo giá trị đã thay đổi trước đó.
    if (event) {
      // Gọi đến mà set và trong hàm này sẽ gọi tới cập nhật
      this.setBoxShadowFromConfig();
    } else {
      this.class['frame-search-by-keyword__products--item']['box-shadow'] = '';
      this.updateClass();
    }
    this.updateConfig();
  }
  /*--------- Thay đổi mũi tên điều hướng trang -------------------*/
  onChangeArrows(arrows) {
    this.config['icon_pagination']['arrow_left_icon'] = arrows.icon_left;
    this.config['icon_pagination']['arrow_right_icon'] = arrows.icon_right;
    this.updateConfig()
  }
  /** Hàm thực hiện cập nhật lại trường box-shadow cho frame từ trường property_box_shadow config
   *
   */
  setBoxShadowFromConfig() {
    let propertyShadow =
      this.config['frame-search-by-keyword__products--item']['property_box_shadow'];
    this.class['frame-search-by-keyword__products--item']['box-shadow'] = `${propertyShadow.type == 'outset' ? '' : propertyShadow.type
      } ${propertyShadow['h-offset']}px ${propertyShadow['v-offset']}px ${propertyShadow['blur']
      }px ${propertyShadow['spread']}px ${propertyShadow['color']}`;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý font-size icon left
   *
   * @param event
   */
  handleFontSizeIconLeft(event) {
    let value = `${event}px`;
    this.class['frame-search-by-keyword__left-arrow--icon']['font-size'] =
      this.class['frame-search-by-keyword__left-arrow--icon']['height'] =
      this.class['frame-search-by-keyword__left-arrow--icon']['width'] =
      value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý font-size icon right
   *
   * @param event
   */
  handleFontSizeIconRight(event) {
    let value = `${event}px`;
    this.class['frame-search-by-keyword__right-arrow--icon']['font-size'] =
      this.class['frame-search-by-keyword__right-arrow--icon']['height'] =
      this.class['frame-search-by-keyword__right-arrow--icon']['width'] =
      value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý icon trái cách bên trái
   *
   * @param event
   */
  handleLeftArrowLeft(event) {
    let value = `${event}%`;
    this.class['frame-search-by-keyword__left-arrow']['left'] = value;
    this.updateClass();
  }
  /** Hàm thực hiện xử lý icon phải cách bên phải
   *
   * @param event
   */
  handleRightArrowRight(event) {
    let value = `${event}%`;
    this.class['frame-search-by-keyword__right-arrow']['right'] = value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý icon trái cách bên trên
   *
   * @param event
   */
  handleTopArrowLeft(event) {
    let value = `${event}%`;
    this.class['frame-search-by-keyword__left-arrow']['top'] = value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý icon phải cách bên trên
   *
   * @param event
   */
  handleTopArrowRight(event) {
    let value = `${event}%`;
    this.class['frame-search-by-keyword__right-arrow']['top'] = value;
    this.updateClass();
  }

  // //Hàm update class
  // updateClass() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_class']: this.class,
  //     })
  //     .then((bool: any) => {

  //     });
  // }

  // //Hàm update class
  // updateConfig() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_config']: this.config,
  //     })
  //     .then((bool: any) => {

  //     });
  // }

  // updateStaticData() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
  //     staticdata: this.objectChoosing.staticdata,
  //   })
  //     .then((bool: any) => {

  //     })
  // }
}
